import { render, staticRenderFns } from "./Trees.vue?vue&type=template&id=6f477444&scoped=true"
import script from "./Trees.vue?vue&type=script&lang=js"
export * from "./Trees.vue?vue&type=script&lang=js"
import style0 from "./Trees.vue?vue&type=style&index=0&id=6f477444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f477444",
  null
  
)

export default component.exports